import React from 'react';
import classnames from 'classnames';
import { TableRow, Tooltip } from '@getsynapse/design-system';
import { TaskDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import intl from 'react-intl-universal';

import { getUserAvartarColumn } from '../../helpers';
import { titleToSnakeCase } from 'utils/functions/dashboard';
import { DrillDownUserSummary } from 'api/normalized/insightDrilldown/types';
import { getStatusColumn } from 'Pages/ProjectsListPage/helpers/tableColumnsValues';

type TaskDrillDownTableRowProps = {
  item: TaskDrillDownItem;
};

const TaskDrillDownTableRow: React.FC<TaskDrillDownTableRowProps> = ({
  item,
}) => {
  return (
    <TableRow
      id={item.id}
      className='group cursor-pointer'
      cells={[
        {
          content: item.task_number,
        },
        { content: item.task_name },
        {
          content: (
            <div>{getStatusColumn(titleToSnakeCase(item.task_status))}</div>
          ),
        },
        { content: item.task_type },
        { content: item.project_title },
        {
          content: (
            <Tooltip
              openMode='hover1'
              position='topCenter'
              contentProps={{
                className: classnames(
                  'bg-neutral-darker shadow-tooltip',
                  'rounded-lg px-4 py-3',
                  'absolute',
                  'w-max whitespace-normal',
                  'text-body',
                  'z-50'
                ),
              }}
              timeout={0}
              showPopper
              className={`w-full truncate`}
              trigger={<span>{(item.programs || []).length}</span>}
            >
              {(item.programs || []).map((i: any) => i.title).join(', ') ||
                intl.get(
                  'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.NO_PROGRAMS'
                )}
            </Tooltip>
          ),
        },
        {
          content:
            item.assignee_data?.length > 0 &&
            getUserAvartarColumn(
              item.assignee_data.map(
                ({
                  avatar_url,
                  status,
                  first_name,
                  last_name,
                  email,
                }: DrillDownUserSummary) => ({
                  avatar_url,
                  status,
                  data: {
                    firstName: first_name,
                    lastName: last_name,
                    email,
                  },
                })
              )
            ),
        },
        { content: item.start_date },
        { content: item.due_date },
        { content: item.demand_hours_in_range },
        { content: item.allocated_hours_in_range },
        { content: item.actual_hours_in_range },
      ]}
    />
  );
};

export default TaskDrillDownTableRow;
